import {
  AddChecklistItemResponse,
  AssetDetail,
  AssetDetails,
  AssetItem,
  AssetStatus,
  ChecklistCategory,
  ChecklistDetail,
  ChecklistType,
  CollectionAndReturnData,
  CollectionReturnDetail,
  CreateAssetItemResponse,
  CreateAssetResponse,
} from '@app/domain';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { AssetDetailDTO, AssetItemDTO } from '../dtos';
import {
  AddChecklistItemResponseDTO,
  AssetDetailsDTO,
  AssetStatusDTO,
  ChecklistCategoryDTO,
  ChecklistDetailDTO,
  ChecklistTypeDTO,
  CollectionAndReturnDataDTO,
  CollectionReturnDetailDTO,
  CreateAssetItemResponseDTO,
  CreateAssetResponseDTO,
} from './../dtos/assets.dto';

// Maps between the API DTO and the Domain Entity
export class AssetsMapper {
  //List of Asset Types
  assetTypeToDomain(
    dto: PaginatedResponse<AssetItemDTO>
  ): PaginatedResponse<AssetItem> {
    return {
      data: dto.data.map(dtoItem => ({
        id: dtoItem.id,
        assetType: dtoItem.assetType,
        noOfAssets: dtoItem.noOfAssets,
        updatedBy: dtoItem.updatedBy,
        updatedAt: dtoItem.updatedAt,
        isActive: dtoItem.isActive,
      })),
      page: dto.page,
      size: dto.size,
      totalElements: dto.totalElements,
      totalPages: dto.totalPages,
    };
  }

  // Asset Type Detail
  assetTypeDetailToDomain(dto: AssetDetailDTO): AssetDetail {
    return {
      assetType: dto.assetType,
      content: dto.content,
      fieldDefinitions: dto.fieldDefinitions,
    };
  }

  //asset item detail
  assetItemDetailToDomain(dto: AssetDetailsDTO): AssetDetails {
    return {
      content: dto.content,
      fieldDefinitions: dto.fieldDefinitions,
      stockConfigs: dto.stockConfigs,
    };
  }

  // Asset Status
  assetStatusToDomain(dto: AssetStatusDTO): AssetStatus {
    return {
      valueListStatus: dto.valueListStatus,
    };
  }

  // Asset Item Checklist
  assetItemChecklistToDomain(dto: ChecklistTypeDTO): ChecklistType {
    return {
      content: dto.content,
      fieldDefinitions: dto.fieldDefinitions,
    };
  }

  // category
  assetItemCategoriesToDomain(
    dto: ChecklistCategoryDTO[]
  ): ChecklistCategory[] {
    return dto.map(item => ({
      id: item.id,
      categoryName: item.categoryName,
      assetTypeId: item.assetTypeId,
    }));
  }

  // Checklist detail
  assetItemChecklistDetailToDomain(dto: ChecklistDetailDTO): ChecklistDetail {
    return {
      assetCheckList: dto.assetCheckList,
      content: dto.content,
      fieldDefinitions: dto.fieldDefinitions,
      adminLogs: dto.adminLogs,
    };
  }

  //Collection and Return
  assetCollectReturnToDomain(
    dto: PaginatedResponse<CollectionAndReturnDataDTO>
  ): PaginatedResponse<CollectionAndReturnData> {
    return {
      data: dto.data.map(item => ({
        id: item.id,
        collectedBy: item.collectedBy,
        collectedOn: item.collectedOn,
        returnedBy: item.returnedBy,
        returnedOn: item.returnedOn,
        shiftDate: item.shiftDate,
        shiftType: item.shiftType,
      })),
      page: dto.page,
      size: dto.size,
      totalElements: dto.totalElements,
      totalPages: dto.totalPages,
    };
  }

  // Collect and Return Detail

  collectionAndReturnDetailToDomain(
    dto: CollectionReturnDetailDTO
  ): CollectionReturnDetail {
    return {
      assetCollectReturn: dto.assetCollectReturn,
      data: dto.data,
    };
  }

  //response submit
  createAssetToDomain(dto: CreateAssetResponseDTO): CreateAssetResponse {
    return {
      id: dto.id,
      assetType: dto.assetType,
      noOfAssets: dto.noOfAssets,
      updatedBy: dto.updatedBy,
      updatedAt: dto.updatedAt,
      assetsInUse: dto.assetsInUse,
      createdBy: dto.createdBy,
      description: dto.description,
      isActive: dto.isActive,
      isRequiredReturn: dto.isRequiredReturn,
    };
  }

  createAssetItemToDomain(
    dto: CreateAssetItemResponseDTO
  ): CreateAssetItemResponse {
    return {
      id: dto.id,
    };
  }

  addChecklistItemToDomain(
    dto: AddChecklistItemResponseDTO
  ): AddChecklistItemResponse {
    return {
      id: dto.id,
    };
  }
}
